import React, { useEffect, useState } from 'react';
import Button from 'rsuite/Button';
import Api from 'util/Api';
import withMiniLoader from 'hoc/withMiniLoader';
import AlertsSidePanel from 'components/AlertsSidePanel';
import AlertToUIBadge, {
  badgeClasses,
} from '../../../../../../util/AlertToUIBadge';

const RoomStatusClass = [
  'badge badge-danger',
  'badge badge-warning',
  'badge badge-info',
  'unknown',
];
const spanStyle = {
  paddingLeft: '8px',
  paddingRight: '8px',
  flexBasis: '0',
  flexGrow: '1',
  fontFamily: 'Metropolis',
  fontWeight: 'bold',
  textTransform: 'uppercase',
  textAlign: 'center',
  color: '#FFFFFF',
  fontSize: '12px',
  lineHeight: '26px',
  borderRight: '1px solid #FFFFFF',
};
const buttonStyle = {
  paddingLeft: '8px',
  paddingRight: '8px',
};

const PatientAlerts = ({ auth, patientId, startTime, endTime }) => {
  const [activeAlerts, setActiveAlerts] = useState([]);
  const [activeAlertsLoading, setActiveAlertsLoading] = useState(false);
  const [alertsPanelVisibility, setAlertsPanelVisibility] = useState(false);

  const openAlertsPanel = () => setAlertsPanelVisibility(true);
  const closeAlertsPanel = () => setAlertsPanelVisibility(false);

  useEffect(() => {
    const loadActiveAlerts = async () => {
      await setActiveAlertsLoading(true);
      const activeAlerts = await Api.withAuth(auth).getActiveAlerts(patientId);
      await setActiveAlerts(activeAlerts);
      await setActiveAlertsLoading(false);
    };

    loadActiveAlerts();
  }, []);

  const renderActiveAlerts = () => {
    if (!activeAlerts.length) return 'No alerts';

    const data = activeAlerts.map((activeAlert, index) => {
      const alertBadgeInfo = AlertToUIBadge(activeAlert);

      return (
        <li key={index}>
          <Button appearance='subtle'>
            <span
              className={'badge-default ' + badgeClasses[alertBadgeInfo.level]}
            >
              {alertBadgeInfo.message}
            </span>
          </Button>
        </li>
      );
    });

    return (
      <ul className='patient__active-alerts-list list-unstyled mb-0'>
        {activeAlerts.map((activeAlert, index) => (
          <li key={index}>
            <Button appearance='subtle' style={buttonStyle}>
              <span className={RoomStatusClass[0]} style={spanStyle}>
                {AlertToUIBadge(activeAlert).message}
              </span>
            </Button>
          </li>
        ))}
      </ul>
    );
  };

  const ActiveAlertsWithLoader = withMiniLoader(
    renderActiveAlerts,
    activeAlertsLoading,
    { minHeight: 'initial' }
  );

  return (
    <div className='patient__alerts'>
      <div className='d-flex align-items-center'>
        <span className='patient__alerts-title pr-2'>Active Alerts</span>
        <ActiveAlertsWithLoader />
      </div>
      <div className='alert-window'>
        <Button appearance='subtle' onClick={openAlertsPanel}>
          View all alerts >
        </Button>
      </div>

      <AlertsSidePanel
        panelOpened={alertsPanelVisibility}
        onCloseHandler={closeAlertsPanel}
        auth={auth}
        patientId={patientId}
        startTime={startTime}
        endTime={endTime}
      />
    </div>
  );
};

export default PatientAlerts;
